import { create } from 'zustand';
import { Language } from './languagesService';

interface CropsStoreStore {
	languages: Language[];
	languagesByIds: Language[];
	setLanguages: (languages: Language[]) => void;
	setLanguagesByIds: (languages: Language[]) => void;
}

export const useLanguagesStore = create<CropsStoreStore>((set) => ({
	languages: [],
	languagesByIds: [],
	setLanguages: (languages) => set({ languages }),
	setLanguagesByIds: (languages) => set({ languagesByIds: languages }),
}));
